import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const MenuEditor = lazyWithRetry(() => import('./MenuEditor'));
type Props = RouteComponentProps;

const MenuEditorRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="menu-editor">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <MenuEditor />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default MenuEditorRoutes;
